
import React from "react";
import DashboardWelcome from "@/components/dashboard/DashboardWelcome";
import DashboardNotificationStats from "@/components/dashboard/DashboardNotificationStats";
import DashboardRecentNotifications from "@/components/dashboard/DashboardRecentNotifications";
import DashboardTeamActivity from "@/components/dashboard/DashboardTeamActivity";
import DashboardWeather from "@/components/dashboard/DashboardWeather";
import { useIsMobile } from "@/hooks/use-mobile";

const Dashboard = () => {
  const isMobile = useIsMobile();
  return (
    <div className={isMobile ? "space-y-3" : "space-y-6"}>
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        <DashboardWelcome />
        <DashboardWeather />
      </div>

      <DashboardNotificationStats />

      <div className="grid gap-6 lg:grid-cols-2">
        <DashboardRecentNotifications />
        <DashboardTeamActivity />
      </div>
    </div>
  );
};

export default Dashboard;
